import Vue from 'vue';

/**
 * Notify error and callback if it's given
 * If arg is callback, returns a function that receives error and call arg
 * If arg is string, just toast arg
 * @param {Mixed} arg callback or message error
 */
export default function notifyError(arg = () => { }) {
  if (typeof arg === 'string') {
    return Vue.toasted.error(arg);
  }
  return (error) => {
    Vue.toasted.error(error);
    arg();
  };
}
